<app-view #view [code]="'families.edit'" [model]="family" (onEvent)="onEvent($event)"></app-view>
